import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface ReclamationParams {
    chantierId: number;
    adresseSiteId: number;
    description: string;
    reclamationId?: number;
}

class ReclamationService {
    public async sendReclamation(body: ReclamationParams) {
        return http.post(Routes.ReclamationRoutes.SendReclamation(), body);
    }
    public async cloturerReclamation(reclamationId: number) {
        return http.post(Routes.ReclamationRoutes.CloturerReclamation(reclamationId));
    }
}

export default new ReclamationService();
